/**
 * c2c聊天通知列表模板
 * Bai.Zhiming
 * 2019-7-19
 */
angular.module('c2cChartListModule', []).
directive("c2cChartList", ['$timeout', function($timeout) {
    return {
        restrict: "E",
        replace: true,
        scope: false,
        templateUrl: './IM/chatWindow/chartList/c2cChartList/c2cChartList_tpl.html',
        link(scope, $element, $attrs) {
            
        }
    };
}]);